export const PRODUCTS_GRAPHQL_API_BASE_URL = process.env.NEXT_PUBLIC_PRODUCTS_GRAPHQL_API_BASE_URL;
export const REWARDS_SERVICE_GRAPHQL_API_BASE_URL = process.env.NEXT_PUBLIC_REWARDS_API_BASE_URL;
export const SEARCH_SERVICE_GRAPHQL_API_BASE_URL = process.env.NEXT_PUBLIC_SEARCH_API_BASE_URL;
export const CPGPULSE_SERVICE_GRAPHQL_API_BASE_URL = process.env.NEXT_PUBLIC_CPGPULSE_API_BASE_URL;
export const SM_API_HOST = process.env.NEXT_PUBLIC_SM_API_HOST;
export const SM_API_BASE_URL = `${SM_API_HOST}/api/v1/ams`;
export const USERS_GRAPHQL_API_BASE_URL = process.env.NEXT_PUBLIC_USER_SERVICE_API_BASE_URL;